import Vue from 'vue'

Vue.filter('priceDecimal', value => Math.round(value * 100) / 100)

Vue.filter('trailingZeros', (val, amount = 2) => {
    val += ""
    let splitted = val.split(".")
    if (splitted.length === 1) {
        return val + ".".padEnd(amount + 1, "0")
    } else if (splitted.length > 1) {
        return splitted[0] + "." + splitted[1].padEnd(amount, "0")
    }
    return val
})
